import { Router } from '@digitalbranch/app'
import {
  aboutMe,
  homePage,
  projectsPage,
} from '../pages'

export const router = new Router()

router.set(
  {
    path: '/',
    component: homePage,
  },
  {
    path: '/projects',
    component: projectsPage,
  },
  {
    path: '/about-me',
    component: aboutMe,
  },
)
